import React from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Label } from '@nooz-optics/nooz-components-lib';
import '../../../../../../styles/global.css';
import clsx from 'clsx';
import { returnCurrencyCharFromCode } from 'utils/globals';
import {
  productWithLiveShopifyState,
  variantState,
} from 'utils/recoil/product';
import { withSuspense } from 'utils/hocs/withSuspense';
import { Button } from '../../../../../UI/Elements';

export const ProductMainPricePicker: React.FC<ProductMainPricePickerProps> =
  withSuspense(({ label, variant, variants, category }) => {
    const setVariant = useSetRecoilState(variantState);
    const shopifyProductState = useRecoilValue(productWithLiveShopifyState);

    const returnPriceButtons = () =>
      shopifyProductState?.variants.map((price, index) => {
        const isPriceSelected = variant?.denominations === price?.sku;
        const isLastPrice = index === variants.length - 1;
        const currency = returnCurrencyCharFromCode(
          price.priceV2?.currencyCode
        );
        const priceLabel = `${price.priceV2?.amount} ${currency}`;
        const selectedVariant = variants.find(
          (v) => v.denominations === price.sku
        );
        return (
          <div className={clsx(`${!isLastPrice && 'mr-2'}`, 'mb-4')}>
            <Button
              size='base'
              type='contained'
              color={isPriceSelected ? category?.color : { classname: 'white' }}
              label={{ text: priceLabel }}
              onClick={() => {
                setVariant({
                  ...variant,
                  images: selectedVariant?.images,
                  denominations: price.sku,
                  price: { ...price },
                });
              }}
            />
          </div>
        );
      });

    return (
      <div className='w-full border-b'>
        <div className='flex my-3 items-center'>
          <Label
            weight='bold'
            text={label?.text}
          />
        </div>
        <div className='flex flex-wrap'>{returnPriceButtons()}</div>
      </div>
    );
  }, <div className='bg-gray-200 mb-4 rounded-full mr-2 animate-pulse w-12 h-7' />);
